export default __webpack_public_path__ + "static/media/DielDarkLogo.39a3c7a8.svg";